import { mapIcon } from '../shared/mapa/mapa-tools/mapa-icons';

export class Movil {

    cod_equipo_rastreo   : number;
    des_equipo_ratreo    : string;
    fecha_hora?          : string;
    latitud?             : number;
    longitud?            : number;
    matricula?           : string;
    nro_vehiculo?        : number;
    orientacion?         : number;
    velocidad?           : number;
    color?               : any;
    label?               : any;
    icono?               : any;
    active?               : any;
    mapIcon = new mapIcon();

}